import { TemplateDisplayContent } from "@/components/Dialogs/DisplayTemplate";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
export default function TemplateDisplay() {
    const { code } = useParams();

    const template = useQuery({
        queryKey: ["template", code],
        queryFn: async () => {
            const response = await fetch(`__SITE_BASE__/api/templates/${code}`);
            return response.json();
        },
    });

    if (template.isLoading) return <div className="h-screen flex-col px-2 -ml-4 -mr-4 sm:px-0 w-screen flex items-center justify-center bg-gradient-to-b from-brand-green/20 to-brand-darkest" />
    if (!template.data?.template) return <div className="h-screen flex-col px-2 -ml-4 -mr-4 sm:px-0 w-screen flex items-center justify-center bg-gradient-to-b from-brand-green/20 to-brand-darkest">
        <div className="flex items-center h-48 shadow-xl">
            <div className="rounded-r-lg sm:rounded-r-none sm:rounded-l-lg gap-2 flex-col bg-brand-dark text-white h-full px-2 sm:px-32 py-2 w-auto flex items-center justify-center">
                <div className="flex flex-col gap-2 items-center">
                    <p className="text-2xl font-bold text-center">
                        Template Not Found
                    </p>
                    <button
                        onClick={() => window.history.back()}
                        className="mt-4 px-4 py-2 bg-brand-green text-white rounded-lg"
                    >
                        Go Back
                    </button>
                </div>
            </div>
        </div>
    </div>
    return (
        <div className="h-screen flex-col px-2 -ml-4 -mr-4 sm:px-0  w-screen flex items-center justify-center bg-gradient-to-b from-brand-green/20 to-brand-darkest">
            <TemplateDisplayContent template={template.data?.template} team={template.data?.team} />
        </div>
    )
}    